<template>
  <div class="service-detail">
    <div class="param">
      <p class="param-name">Name:</p>
      <p>{{service.name}}</p>
    </div>

    <div class="param" v-for="property in service.properties" :key="property.key">
      <p class="param-name">{{property.key}}</p>
      <p v-if="property.value.startsWith('http')"><a target="_blank" :href="property.value">{{property.value}}</a></p>
      <p v-else>{{property.value}}</p>
    </div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceDetail',
  props: {
    service: {
      type: Object,
      requierd: true  
    }
  }
}
</script>

<style>
.service-detail {
  background-color: white;
}
.param-name {
  font-size: 12px;
  width: 70px;
}
</style>